import NotFoundView404 from '@/components/pages/404'
import LayoutView from '@/components/pages/Homepage/Layout'
import ContainerView from '@/components/pages/Organization/Container'

import HomepageRoutes from './homepageRoutes'
import OrganizationRoutes from './organizationRoutes'

// Routes
const routes = [
  {
    path: '/',
    component: LayoutView,
    children: HomepageRoutes
  }, {
    path: '/organization',
    component: ContainerView,
    children: OrganizationRoutes,
    meta: {auth: true, roles: ['owner', 'manager', 'employee']}
  }, {
    // not found handler
    path: '*',
    component: NotFoundView404
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js